import Form from "./Form.js";
import Fetcher from "../api/Fetcher.js";
import currentUserStore from "../stores/data/currentUserStore.js";
import defaultTheme from "../util/defaultTheme.js";

class EditSettingsForm extends Form {
	static title = "Edit Settings";
	static code = "edit-settings";
	static submitValue = "Save";

	static getTheme(currentUser) {
		if (currentUser?.settings?.theme) return currentUser.settings.theme;
		return defaultTheme();
	}

	static initialFields({ currentUser }) {
		return [
			{
				type: "input",
				inputType: "number",
				value: currentUser.settings.pageSize,
				label: "Page size",
				id: "settings-page-size",
				min: 1,
				max: 100,
			},
			{
				type: "input",
				inputType: "theme",
				value: this.getTheme(currentUser),
				label: "Theme",
				id: "settings-theme",
			},
			{
				type: "input",
				inputType: "number",
				value: currentUser.settings.quoteDepth,
				label: "Depth to auto-show quotes",
				id: "settings-quote-depth",
				min: 0,
			},
			{
				type: "checkbox",
				value: currentUser.settings.emailNotifications,
				label: "Email notifications",
			},
			{
				type: "checkbox",
				value: currentUser.settings.newestPostFirst,
				label: "Newest post first",
			},
			{
				type: "input",
				inputType: "select",
				items: ["Optional", "Mandatory", "None"],
				value: currentUser.settings.postTopicVerification,
				label: "Verify that a draft is being posted to the intended topic",
			},
			{
				type: "checkbox",
				label: "Autofill post topic verification",
				value: currentUser.settings.postTopicVerificationAutofill,
			},
		];
	}

	static async submit({ fields }) {
		const pageSize = fields[0].value;
		const theme = fields[1].value;
		const quoteDepth = fields[2].value;
		const emailNotifications = fields[3].value;
		const newestPostFirst = fields[4].value;
		const postTopicVerification = fields[5].value;
		const postTopicVerificationAutofill = fields[6].value;
		return Fetcher.updateSettings({
			pageSize,
			theme,
			quoteDepth,
			emailNotifications,
			newestPostFirst,
			postTopicVerification,
			postTopicVerificationAutofill,
		});
	}

	static handleSuccess(json) {
		currentUserStore.updateCurrentUser(json);
	}
}

export default EditSettingsForm;
